export default __webpack_public_path__ + "static/media/3-aumento.8de4230e.svg";